import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { OotdReviewApp } from "./OotdReviewApp";
import "./ootd-review.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <OotdReviewApp />
  </StrictMode>,
);
